

window.addEventListener("load", function () {
   

});
